

window.addEventListener("load", function () {
   

});
